import React from 'react';
import './each_location.css';
import { Container, Row, Col } from "react-bootstrap";
import MediaQuery from "react-responsive";


const Our_Facilities = (props) => {
    const sectionTitle = props.valDataThree.facilities_tag.split(" ");

    //  console.log(props.valDataThree);


    function facilityChoice(val, index, idx) {
        if (evenOrodd(index)) {
            return (
                <>
                    <Row className="mb-5">
                        <Col md={6} key={Math.random()}>
                            <div className="panel-img">
                                <img src={val.facility_image.data[0].attributes.formats.small.url} alt="BLC Facilities" className="facility-img" />
                            </div>
                        </Col>
                        <Col md={6} key={Math.random()}>
                            <div className="panel text-left">
                                <h4 className='facilities-sub-h'>{val.title}</h4>
                                <hr className="facility-hr" />
                                <p>
                                    {val.Facility_description}
                                </p>
                            </div>
                        </Col>
                    </Row>
                </>
            )
        } else {
            return (
                <>
                    <Row className="mb-5">
                        <Col md={6} key={Math.random()}>
                            <div className="panel-right text-left">
                                <h4 className='facilities-sub-h'>{val.title}</h4>
                                <hr className="facility-hr" />
                                <p>
                                    {val.Facility_description}
                                </p>
                            </div>
                        </Col>
                        <Col md={6} key={Math.random()}>
                            <div className="panel-img">
                                <img src={val.facility_image.data[0].attributes.url} alt="BLC Facilities" className="facility-img" />
                            </div>
                        </Col>
                    </Row>
                </>
            )
        }
    }

    function evenOrodd(index) {

        if (index === 0) {
            return true;
        } {
            return index % 2 === 0 ? true : false;
        }

    }
    return (
        <section className="facility-bg">

            <Container className="justify-content-center" style={{ flexWrap: 'wrap' }}>
                {/* <h2 style={{ color: '#ec008c', textAlign: 'center' }}>{props.valDataThree.facilities_tag}</h2>
                <hr /> */}
                <h2 className="sectionHeading titles mb-3">
                    <span className='titles-black me-2'>{sectionTitle[0]}</span>
                    <span>{sectionTitle[1]}</span>
                </h2>

                <MediaQuery minWidth={768}>
                    <Container className="py-3">
                        <Row>
                            {props.valDataThree.facility.map((val, index, idx) => (
                                facilityChoice(val, index, idx)
                            ))}
                        </Row>
                    </Container>
                </MediaQuery>
                <MediaQuery maxWidth={767}>
                    <Container className="py-3">
                        <Row className="mb-5">
                            {props.valDataThree.facility.map((val, index, idx) => (
                                <>
                                    <Col md={6} key={Math.random()}>
                                        <div className="panel-img">
                                            <img src={val.facility_image.data[0].attributes.url} alt="BLC Accomodation" className="facility-img" />
                                        </div>
                                    </Col>
                                    <Col md={6} key={Math.random()}>
                                        <div className="panel mb-4 text-left">
                                            <h4 className='facilities-sub-h'>{val.title}</h4>
                                            <hr className="facility-hr" />
                                            <p>
                                                {val.Facility_description}
                                            </p>
                                        </div>
                                    </Col>
                                </>
                            ))}
                        </Row>
                    </Container>
                </MediaQuery>
                {/* <Container className="py-3">
                    <Row>
                        <Col md={6}>
                            <div className="panel-img">
                                <img src="https://drive.google.com/uc?export=view&id=1VN26bQLHzpPhepGPXIN6KxBLdHYEtuuf" alt="BLC Accomodation" className="facility-img" alt="Pray" className />
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="panel text-left">
                                <h3>Class Room</h3>
                                <hr className="facility-hr" />
                                <p>
                                    Facilitation rooms for conventional training sessions with projection and sound system facilities. BLC has fully equipped computer labs.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <Container className="py-3">
                    <Row>
                        <Col md={6}>
                            <div className="panel-right text-left">
                                <h3>Green Campus</h3>
                                <hr className="facility-hr" />
                                <p>
                                    Facilitation rooms for conventional training sessions with projection and sound system facilities. BLC has fully equipped computer labs.
                                </p>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="panel-img">
                                <img src="https://drive.google.com/uc?export=view&id=1VN26bQLHzpPhepGPXIN6KxBLdHYEtuuf" alt="BLC Accomodation" className="facility-img" alt="Pray" className />
                            </div>
                        </Col>
                    </Row>
                </Container>
                <Container className="py-3">
                    <Row>
                        <Col md={6}>
                            <div className="panel-img">
                                <img src="https://drive.google.com/uc?export=view&id=1VN26bQLHzpPhepGPXIN6KxBLdHYEtuuf" alt="BLC Accomodation" className="facility-img" alt="Pray" className />
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="panel text-left">
                                <h3>Dining</h3>
                                <hr className="facility-hr" />
                                <p>
                                    Facilitation rooms for conventional training sessions with projection and sound system facilities. BLC has fully equipped computer labs.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container> */}
            </Container>
        </section>
    );
};

export default Our_Facilities